export default __webpack_public_path__ + "static/hepato-zasilvat-organ-header-fe1d16e5dd58980fd3e4606cfb203b34.jpg";